export default function ThongTinVon({ data, formatNumber }) {
  return (
    <div className="form-body form-bordered-2 row-store">
      <div className="row col-md-12 ">
        <div className="col-md-12">
          <div className="form-group last-1">
            <div className="row" style={{ padding: "20px" }}>
              <div className="col-md-6 color7-bold">Vốn đầu tư</div>
              <div className="col-md-6 color-do-bold text-right">
                {formatNumber(Math.round(data.VonDauTu))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-group last-1">
            <div className="row" style={{ padding: "20px" }}>
              <div className="col-md-6 color7-bold">Quỹ tiền</div>
              <div className="col-md-6 color-xanh-bold text-right">
                {formatNumber(Math.round(data.QuyTienMat))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-group last-1">
            <div className="row" style={{ padding: "20px" }}>
              <div className="col-md-6 color7-bold">Tiền đang cho vay</div>
              <div className="col-md-6 color-do-bold text-right">
                {formatNumber(Math.round(data.TienDangChoVay))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
